<div class="row">
    <div class="col-16">
        <h5>Creditable Coverage</h5>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <div class="row">
            <div class="col-24">
                <h5>Does the Applicant have Creditable Coverage</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <!-- radio buttons -->
            </div>
        </div>
    </div>
    <div class="col-12">
        <div class="row">
            <div class="col-24">
                <p>
                    Number of months the applicant did not have any creditable prescription drug coverage
                    but was eligible for Medicare Part D. Up to 3 characters - digits only
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <!-- text box -->
            </div>
        </div>
    </div>
</div>
    